import { debugLocalStorage as debug } from 'Lib/debug';
import isNil from 'Lib/utils/isNil';

const LOCAL_STORAGE_TEST_KEY = '__lstest__';

export function hasStorage() {
  try {
    localStorage.setItem(LOCAL_STORAGE_TEST_KEY, '1');
    localStorage.getItem(LOCAL_STORAGE_TEST_KEY);
    localStorage.removeItem(LOCAL_STORAGE_TEST_KEY);
    return true;
  } catch (error) {
    return false;
  }
}

export function getStorage() {
  if (!hasStorage()) {
    debug('localStorage support not found - using in-memory storage only');
    const data: Partial<{
      [key: string]: string;
    }> = {};
    return {
      getItem(key: string) {
        return data[key] ?? null;
      },
      setItem(key: string, value: string) {
        const storedValue = isNil(value) ? '' : value;
        data[key] = storedValue;
      },
      removeItem(key: string) {
        delete data[key];
      },
      getAllKeys() {
        return Object.keys(data);
      },
    };
  }

  return {
    getItem(key: string) {
      return localStorage.getItem(key);
    },
    setItem(key: string, value?: string | null) {
      const storedValue = isNil(value) ? '' : value;
      localStorage.setItem(key, storedValue);
    },
    removeItem(key: string) {
      localStorage.removeItem(key);
    },
    getAllKeys() {
      return Object.keys(localStorage).filter((key) => localStorage.getItem(key) != null);
    },
  };
}

export const storage = getStorage();

export default {
  getItem(key: string): Promise<string | null> {
    return new Promise((resolve) => {
      resolve(storage.getItem(key));
    });
  },
  setItem(key: string, item: string): Promise<void> {
    return new Promise((resolve) => {
      resolve(storage.setItem(key, item));
    });
  },
  removeItem(key: string): Promise<void> {
    return new Promise((resolve) => {
      resolve(storage.removeItem(key));
    });
  },
  getAllKeys(): Promise<string[]> {
    return new Promise((resolve) => {
      resolve(storage.getAllKeys());
    });
  },
};
